<table class="table table-bordered" id="table" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>{{ writerI18n?.nameI18n }}</th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>{{ writerI18n?.nameI18n }}</th>
    </tr>
  </tfoot>
  <tbody>
    <tr *ngFor="let t of writers">
      <td>{{ t.name }}</td>
    </tr>
  </tbody>
</table>
